import { pickT } from "@repo/shared";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { T } from "./settings-portfolio-forecast-form.i18n";

type SettingsPortfolioForecastFormProps = {
  flowLanguage: string;
  showStatistics: boolean;
  onShowStatisticsChange: (show: boolean) => void;
  showTable: boolean;
  onShowTableChange: (show: boolean) => void;
  compareWithBank: boolean;
  onCompareWithBankChange: (show: boolean) => void;
};

export function SettingsPortfolioForecastForm({
  flowLanguage,
  showStatistics,
  onShowStatisticsChange,
  showTable,
  onShowTableChange,
  compareWithBank,
  onCompareWithBankChange,
}: SettingsPortfolioForecastFormProps) {
  const t = pickT(T, flowLanguage);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <Label htmlFor="forecast-show-statistics" className="text-base">
            {t.showStatistics}
          </Label>
          <p className="text-sm text-muted-foreground">{t.showStatisticsDesc}</p>
        </div>
        <Switch
          id="forecast-show-statistics"
          checked={showStatistics}
          onCheckedChange={onShowStatisticsChange}
        />
      </div>

      <div className="flex items-center justify-between">
        <div>
          <Label htmlFor="forecast-show-table" className="text-base">
            {t.showTable}
          </Label>
          <p className="text-sm text-muted-foreground">{t.showTableDesc}</p>
        </div>
        <Switch id="forecast-show-table" checked={showTable} onCheckedChange={onShowTableChange} />
      </div>

      <div className="flex items-center justify-between">
        <div>
          <Label htmlFor="forecast-compare-with-bank" className="text-base">
            {t.compareWithBank}
          </Label>
          <p className="text-sm text-muted-foreground">{t.compareWithBankDesc}</p>
        </div>
        <Switch
          id="forecast-compare-with-bank"
          checked={compareWithBank}
          onCheckedChange={onCompareWithBankChange}
        />
      </div>
    </div>
  );
}
